import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import Files from 'react-files';

import { 
  loadCategories,
  loadCategory,
  addCategory,
  editCategory,
} from '../../reducers/categories';

import update from 'immutability-helper';

import axios from 'axios';

class CategoryEditor extends Component {

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    category: {
      category_name: '',
    },
    categoryImageFile: null,
    categoryImageFileSrc: null,
    isEditingCategoryImage: false,
    categoryLogoFile: null,
    categoryLogoFileSrc: null,
    isEditingCategoryLogo: false,
    errors: {
      category_name: null,
    },
    canAdd: false,
    canEdit: false,
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

  }

  componentDidUpdate = (prevProps, prevState) => {
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.loadCategoryByID();
    }
  }

  loadCategoryByID = () => {
    if(this.state.id){
      this.props.loadCategory(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({category: resp.data});
          this.mapCategoryToFields();
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  mapCategoryToFields = () => {
    this.mapCategoryImage();
    this.mapCategoryLogo();
  }

  mapCategoryImage = () => {
    if(this.state.category.category_image){
      axios.get(this.state.category.category_image).then((resp) => {
        const file = new File([resp.data], this.state.category.category_image.split('/').pop(), {type: "image/*"});
        this.setState({categoryImageFile: file, categoryImageFileSrc: this.state.category.category_image});
      });
    }
  }

  mapCategoryLogo = () => {
    if(this.state.category.category_logo){
      axios.get(this.state.category.category_logo).then((resp) => {
        const file = new File([resp.data], this.state.category.category_logo.split('/').pop(), {type: "image/*"});
        this.setState({categoryLogoFile: file, categoryLogoFileSrc: this.state.category.category_logo});
      });
    }
  }


  handleCategoryNameChange = (e) => {
    this.setState(update(this.state, {category: {category_name: {$set: e.target.value}}}), () => {

      if(this.state.category.category_name.length === 0) {
        this.setState(update(this.state, {errors: {category_name: {$set: 'Category name must not be empty'}}}));
      } else if( this.state.category.category_name.length > 0) {
        this.setState(update(this.state, {errors: {category_name: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  handleCategoryImageChange = (file) => {
    if(file.length){
      this.setState({categoryImageFile: file[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({categoryImageFileSrc: e.target.result, isEditingCategoryImage: true});
      };
      reader.readAsDataURL(file[0]);
    }
  }

  handleCategoryImageChangeError = (error, file) => {
    window.alert(`${error.message}`);
  }

  removeCategoryImage = () => {
    this.setState({categoryImageFile: null, categoryImageFileSrc: null});
  }

  handleCategoryLogoChange = (file) => {
    if(file.length){
      this.setState({categoryLogoFile: file[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({categoryLogoFileSrc: e.target.result, isEditingCategoryLogo: true});
      };
      reader.readAsDataURL(file[0]);
    }
  }

  handleCategoryLogoChangeError = (error, file) => {
    window.alert(`${error.message}`);
  }

  removeCategoryLogo = () => {
    this.setState({categoryLogoFile: null, categoryLogoFileSrc: null});
  }

  addCategory = () => {
    
    const category = Object.assign({}, this.state.category);
    category.description = "";
    delete category.category_id;    

    const data = new FormData()
    data.append('data', JSON.stringify(category));

    if(this.state.isEditingCategoryImage){
      data.append('file', this.state.categoryImageFile);
    }

    if(this.state.isEditingCategoryLogo){
      data.append('file2', this.state.categoryLogoFile);
    }

    this.props.addCategory(data, (resp) => {
      this.setState({added: true});
      this.props.loadCategories();
    });
  }

  editCategory = () => {
    
    const category = Object.assign({}, this.state.category);
    delete category.category_id; 
    delete category.category_image;
    delete category.category_image_date_created;
    delete category.category_logo;
    delete category.category_logo_date_created;
    category.description = "";

    const data = new FormData()
    data.append('data', JSON.stringify(category));

    if(this.state.isEditingCategoryImage){
      data.append('file', this.state.categoryImageFile);
    }

    if(this.state.isEditingCategoryLogo){
      data.append('file2', this.state.categoryLogoFile);
    }

    this.props.editCategory(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadCategories();
    });
  }

  validateFields = () => {
    let flag = true;

    if(this.state.category.category_name.length === 0) {
      flag = false;
    } else if( this.state.category.category_name.length > 0) {
    }

    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/categories'/>;
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Category</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/categories'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addCategory} disabled={this.props.isAddingCategory || !this.state.canAdd} >Add Category</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editCategory} disabled={this.props.isEditingCategory || !this.state.canEdit} >Edit Category</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Category Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="categoryName">Category Name *</label>
                    <input type="text" className="form-control" id="categoryName" value={this.state.category.category_name} onChange={this.handleCategoryNameChange} placeholder="Category Name" autoFocus />
                    {this.state.errors.category_name &&
                      <small id="categoryNameError" className="form-text text-muted">{this.state.errors.category_name}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="categoryImage">Category Image</label>
                    {this.state.categoryImageFile ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.categoryImageFileSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.categoryImageFile.name} <br/>
                          {this.state.categoryImageFile.size} <br/>
                          {this.state.categoryImageFile.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeCategoryImage}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="categoryImage" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleCategoryImageChangeError} onChange={this.handleCategoryImageChange} maxFileSize={500000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add Image</a></div>
                      </Files>
                    }
                    <small id="categoryImageError" className="form-text text-muted">Max file size 500kB.</small>
                  </div>

                  {/* <div className="form-group">
                    <label htmlFor="categoryImage">Category Logo</label>
                    {this.state.categoryLogoFile ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.categoryLogoFileSrc})`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.categoryLogoFile.name} <br/>
                          {this.state.categoryLogoFile.size} <br/>
                          {this.state.categoryLogoFile.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeCategoryLogo}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="categoryLogo" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleCategoryLogoChangeError} onChange={this.handleCategoryLogoChange} maxFileSize={500000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add Logo</a></div>
                      </Files>
                    }
                    <small id="categoryLogoError" className="form-text text-muted">Max file size 500kB.</small>
                  </div> */}
                </form>
              </div>
            </div>
          </div>


          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/categories'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addCategory} disabled={this.props.isAddingCategory || !this.state.canAdd} >Add Category</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editCategory} disabled={this.props.isEditingCategory || !this.state.canEdit} >Edit Category</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  categories: state.categories.categories,
  isLoadingCategory: state.categories.isLoadingCategory,
  isAddingCategory: state.categories.isAddingCategory,
  isEditingCategory: state.categories.isEditingCategory,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadCategory,
      loadCategories,
      addCategory,
      editCategory,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CategoryEditor);


// WEBPACK FOOTER //
// ./src/modules/Categories/CategoryEditor.js